import type {
  ICourseContentsDto,
  ICourseContentsGetAllParams,
  ICourseContentsResponse,
} from "./types";
import type { IPathBaseParam, IPathByIdParam } from "./path";

import type { IApiResponse, IPagination, IPaginationParams } from "@/api";
import { createGetAllApi } from "@api/util/createGetAllApi";
import { createPostApi } from "@api/util/createPostApi";
import { createGetApi } from "@api/util/createGetApi";
import { createPatchApi } from "@api/util/createPatchApi";
import { createDeleteApi } from "@api/util/createDeleteApi";
import { documents } from "@api/courses/contents/contentDocuments/api";
import type { ICourseResponse } from "@api/courses/types";

const getAllApis = createGetAllApi<
  IApiResponse<
    IPagination<ICourseContentsResponse, { course: ICourseResponse }>
  >,
  IPathBaseParam,
  IPaginationParams & ICourseContentsGetAllParams
>("courses.contents");
const postApis = createPostApi<
  IApiResponse<ICourseContentsResponse>,
  IPathBaseParam,
  ICourseContentsDto
>("courses.contents");
const getApis = createGetApi<
  IApiResponse<ICourseContentsResponse>,
  IPathByIdParam,
  object
>("courses.contents");
const patchApis = createPatchApi<
  IApiResponse<ICourseContentsResponse>,
  IPathByIdParam,
  ICourseContentsDto
>("courses.contents");
const deleteApis = createDeleteApi<
  IApiResponse<ICourseContentsResponse>,
  IPathByIdParam
>("courses.contents");

export const contents = {
  ...getAllApis,
  ...getApis,
  ...postApis,
  ...patchApis,
  ...deleteApis,
  documents,
};
